import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=58bf3c6c&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=58bf3c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bf3c6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58bf3c6c')) {
      api.createRecord('58bf3c6c', component.options)
    } else {
      api.reload('58bf3c6c', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=58bf3c6c&scoped=true&", function () {
      api.rerender('58bf3c6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BXS9vb2G7h7a/JS/teamMember.vue"
export default component.exports